

const defaultProps = {
};

export default defaultProps;



// WEBPACK FOOTER //
// ./src/chat-sidebar/default-props.js